var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", { staticClass: "parking" }, [
        _c("div", { staticClass: "parking__wrapper" }, [
          _c("div", { staticClass: "parking__top" }, [
            _c("h1", { staticClass: "parking__title" }, [
              _vm._v("\n                Паркинг\n                "),
              _c("span", { staticClass: "parking__title-label" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.data.elements.length) +
                    "\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.view === "plan"
              ? _c("div", { staticClass: "parking__description" }, [
                  _c("div", {
                    staticClass: "parking__info",
                    domProps: { innerHTML: _vm._s(_vm.data.description.info) },
                  }),
                  _vm._v(" "),
                  _vm.data.description.advantages
                    ? _c(
                        "ul",
                        { staticClass: "parking__advantages" },
                        _vm._l(
                          _vm.data.description.advantages,
                          function (item) {
                            return _c(
                              "li",
                              {
                                key: item.text,
                                staticClass: "parking__advantages-item",
                              },
                              [_vm._v(_vm._s(item.text))]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "parking__tabs-button" }, [
            _c("div", { staticClass: "parking__tabs-info" }, [
              _vm._v("Выбор машиноместа"),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                class: [
                  "button",
                  _vm.view === "plan"
                    ? "button_theme_color"
                    : " button_theme_stroke",
                  "button_theme_content-width",
                ],
                on: {
                  click: function ($event) {
                    _vm.view = "plan"
                  },
                },
              },
              [_vm._v("На генплане")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                class: [
                  "button",
                  _vm.view === "parametric"
                    ? "button_theme_color"
                    : " button_theme_stroke",
                  "button_theme_content-width",
                ],
                on: {
                  click: function ($event) {
                    _vm.view = "parametric"
                  },
                },
              },
              [_vm._v("По параметрам")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              class: [
                "parking__tabs-fixed",
                { "parking__tabs-fixed_is_top": _vm.headerHide },
              ],
            },
            [
              _c("span", { staticClass: "parking__tabs-fixed-label" }, [
                _vm._v("Машиноместа"),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  class: [
                    "parking__tabs-fixed-tab",
                    { "is-active": _vm.view === "plan" },
                  ],
                  on: {
                    click: function ($event) {
                      _vm.view = "plan"
                    },
                  },
                },
                [_vm._v("на генплане ")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "parking__tabs-fixed-sep" }, [
                _vm._v("/"),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  class: [
                    "parking__tabs-fixed-tab",
                    { "is-active": _vm.view === "parametric" },
                  ],
                  on: {
                    click: function ($event) {
                      _vm.view = "parametric"
                    },
                  },
                },
                [_vm._v(" по параметрам")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "parking__content" },
            [
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                [
                  _c(_vm.view, {
                    tag: "component",
                    attrs: { data: _vm.data },
                    on: { clickElement: _vm.clickElement },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }